import { LitElement, css, html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import styles from "./styles.css?inline";
import { template } from "./template";
import { connectedProperty } from "../../../../infrastructure/state/connected-property";
import { isErrorOccurred, selectErrorMessages } from "../selectors";
import { PrimariaApi } from "@uxland/primary-shell";
import { translate } from "../../../../localization";
import { IErrorHistoryItem } from "../../../domain/model";
import { HandleHistoryItemsAddError } from "../handle-history-items-add-error/request";
import { lazyInject } from "../../../../infrastructure/ioc/container";
import { TYPES } from "../../../../infrastructure/ioc/types";

//@ts-ignore
@customElement("activity-history-partial-data-error")
export class ActivityHistoryPartialDataError extends LitElement {
  render() {
    return html`${template(this)}`;
  }

  static styles = css`
    ${unsafeCSS(styles)}
  `;

  @connectedProperty(isErrorOccurred)
  isErrorOccurred: boolean;

  @connectedProperty(selectErrorMessages)
  errorMessages: Array<IErrorHistoryItem> = [];

  @lazyInject(TYPES.primaryApi)
  api: PrimariaApi;

  handleClickAlert() {
    this.api.broker.send(new HandleHistoryItemsAddError(this.errorMessages));
  }

  getCombinedMessage() {
    const titleMessage = translate("error.partial.title");

    const errorMessages = this.errorMessages.length > 0 ? this.errorMessages.map((error) => error.entityDescription) : [];

    return errorMessages.length > 0
      ? `${titleMessage} ${errorMessages[0]}${errorMessages.length > 1 ? ` i ${errorMessages.slice(1).join(" i ")}` : ""}`
      : titleMessage;
  }
}
